import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {IReferencePathNodeFormSubmissionDate, IReferencePathNodeSpecific, IReferencePathReferenceDetails, ReferencePathReferenceDetailsType} from "~/interfaces/referencePathInterfaces"
import {ReferenceNodeType} from "~/enums/referenceNodeType";
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import {DatetimeMode} from '~/models/datetimeMode'

export class DatePathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.DateTime

  constructor(private dateNode: IReferencePathNodeFormSubmissionDate) {
    super();
  }

  get label(): string {
    switch (this.dateNode.reference_type) {
      case ReferenceNodeType.FormSubmissionDate:
        return 'Date of Submission';
      default:
        this.referenceTypeError('DatePathService#label', this.dateNode);
        break;
    }
  }

  get nodes(): IReferencePathNodeFormSubmissionDate[] {
    return [this.dateNode];
  }

  reference(): ReferenceNodeType {
    return this.dateNode.reference_type;
  }

  get referenceGenericModelType(): GenericType {
    return ModelType.DateTime
  }

  get referenceModelType(): ModelType {
    return this.referenceGenericModelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('DatePathService', this.dateNode, node, decision)
    return decision
  }

  referenceIsCollection = false

  get referenceDetails(): IReferencePathReferenceDetails {
    return {
      type: ReferencePathReferenceDetailsType.DateTimePicker,
      mode: DatetimeMode.Datetime
    }
  }
}